// extracted by mini-css-extract-plugin
export default {"display-none":"g__display-none--YEoqD","u-pointer-cursor":"g__u-pointer-cursor--CQdnf","asset-totals":"g__asset-totals--pMHW7","description":"g__description--CR3s3"};